import { appInfo } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <div className="bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/70">
            <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
              <div className="flex-1 text-center lg:text-left">
                <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">{appInfo.title}</h2>
                <p className="text-sm text-foreground-600 mt-4 leading-relaxed max-w-md mx-auto lg:mx-0">
                  {appInfo.description}
                </p>

                <ul className="flex flex-wrap justify-center lg:justify-start gap-3 mt-6">
                  {appInfo.features.map((feat, i) => (
                    <li
                      key={i}
                      className="flex items-center gap-1.5 text-xs text-foreground-700 bg-background-100 px-3 py-1.5 rounded-full border border-background-200/50"
                    >
                      <i className="ri-check-line text-accent-500 text-sm"></i>
                      {feat}
                    </li>
                  ))}
                </ul>

                <div className="flex flex-col sm:flex-row gap-3 mt-8 justify-center lg:justify-start">
                  <a
                    href="#"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 font-medium text-sm hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-apple-fill text-lg"></i>
                    iOS 版下载
                  </a>
                  <a
                    href="#"
                    className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-secondary-500 text-background-50 font-medium text-sm hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-android-fill text-lg"></i>
                    Android 版下载
                  </a>
                </div>
              </div>

              <div className="flex-shrink-0">
                <div className="w-56 h-80 rounded-2xl overflow-hidden border-4 border-background-200/70 shadow-lg">
                  <img
                    src="https://readdy.ai/api/search-image?query=Mobile%20app%20mockup%20showing%20entertainment%20news%20feed%20on%20phone%20screen%2C%20warm%20orange%20and%20amber%20UI%20design%2C%20clean%20modern%20mobile%20interface%2C%20flat%20design%20style%2C%20no%20text%20visible%20just%20color%20blocks&width=560&height=800&seq=app-mockup-2026&orientation=portrait"
                    alt="51吃瓜在线手机APP界面预览"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}